<template>
  <section class="c-loyaltySection">
    <div class="main-container">
      <div class="content-container">
        <div class="c-loyaltySection__cardContainer">
          <img class="blue" title="loyalty card blue" src="@/assets/cc_blue.png">
          <img class="orange" title="loyalty card orange" src="@/assets/cc_orange.png">
        </div>
        <div class="c-loyaltySection__textContainer">
          <h2>Loyalty means a lot to us</h2>
          <h3>Earn Liberty Advantage points for rewards, discounts and upgrades.</h3>
          <Button name="Apply now" color="blue" :transparent="true"></Button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Button from '@/components/Button'

export default {
  name: 'LoyaltySection',
  components: {
    Button
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/variables.scss";

.c-loyaltySection {

  .main-container {
    background-image: url('~@/assets/loyalty_bg.jpg');
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
    height: 500px;
    position: relative;
  }

  .content-container {
    justify-content: space-between;
    padding: 100px 0;
  }

  &__cardContainer {
    width: 50%;
    position: relative;

    img {
      width: 350px;
      position: absolute;
      top: 50%;
      left: 50%;

      &.orange {
        transform: translate(-57%, -56%);
      }
      &.blue {
        transform: translate(-45%, -41%);
        z-index: 2;
      }
    }
  }

  &__textContainer {
    width: 50%;
    text-align: left;
    padding: 0 12% 0 0;

    h2 {
      font-weight: bold;
      padding: 0 0 $base-padding 0;
    }
    h3 {
      padding: 0 0 calc(#{$base-padding} * 2) 0;
    }
  }
}

@include tablet {
  .c-loyaltySection {
    .main-container {
      height: 370px;
    }
    &__cardContainer {
      img {
        width: 250px;
      }
    }

    &__textContainer {
      padding: 0 5% 0 0;
    }
  }
}

@include phone {
  .c-loyaltySection {
    .main-container {
      height: 500px;
    }

    .content-container {
      flex-direction: column;
      padding: 40px 0;
    }
    &__cardContainer {
      order: 2;
      width: 100%;
      height: 250px;

      img {
        top: 60%;
        width: 220px;
      }
    }

    &__textContainer {
      order: 1;
      width: 100%;
      height: 250px;
      padding: 0;
      text-align: center;
    }
  }
}
</style>
